export const PAGE_LOAD_TIMEOUT = 750;
